<template>
  <div class="speed-control">
    <img
      v-for="(item, index) in options"
      :key="index"
      style="cursor: pointer; width: 50px; margin: 0 5px"
      @click="$emit('change', index)"
      :src="getSpeedImg(item, index)"
      alt=""
    />
  </div>
</template>

<script setup>
import img05 from "@/views/imgBUT/0.5.png";
import img050 from "@/views/imgBUT/0.50.png";
import img01 from "@/views/imgBUT/01.png";
import img1 from "@/views/imgBUT/1.png";
import img2 from "@/views/imgBUT/2.png";
import img02 from "@/views/imgBUT/02.png";
import img3 from "@/views/imgBUT/3.png";
import img03 from "@/views/imgBUT/03.png";

const props = defineProps({
  options: { type: Array, required: true },
  activeIndex: { type: Number, default: 1 }
});

defineEmits(['change']);

const speedImgs = {
  active: [img05, img01, img02, img03],
  inactive: [img050, img1, img2, img3]
};

const getSpeedImg = (item, index) => {
  const isActive = index === props.activeIndex;
  return isActive ? speedImgs.active[index] : speedImgs.inactive[index];
};
</script>

<style lang="less" scoped>
.speed-control {
  width: 300px;
  height: 50px;
  position: fixed;
  right: 0;
  bottom: 78px;
  z-index: 1207;

  img {
    width: 50px;
    height: 50px;
  }
}

@media screen and (max-width: 768px) {
  .speed-control {
    width: auto;
    height: 36px;
    right: 50%;
    transform: translateX(50%);
    bottom: 110px;
    display: flex;
    justify-content: center;

    img {
      width: 32px !important;
      height: 32px !important;
      margin: 0 3px !important;
    }
  }
}

@media screen and (max-width: 360px) {
  .speed-control img {
    width: 26px !important;
    height: 26px !important;
  }
}
</style>
